import React from 'react';

// Components
import MenuComponent from '../../Menu/MenuComponent';

// Kit
import { Avatar, AvatarImage, AvatarFallback, Badge } from '@/components/ui';

const UserComponentMobile = ({ srcAvatar, checked, phone, userName, onClickDisabled, onClickEdit, onClickDelete }) => {

    const initials = ( userName || '' ).trim().charAt(0).toUpperCase() || 'A';

    return (
        <div className="flex items-center justify-between gap-3 rounded-lg border border-border bg-card px-4 py-3 shadow-card md:hidden">
            <div className="flex min-w-0 items-center gap-3">
                <Avatar className="h-11 w-11 border border-border" style={{ opacity: checked ? 1 : 0.55 }}>
                    <AvatarImage src={ srcAvatar } alt={ userName } />
                    <AvatarFallback>{ initials }</AvatarFallback>
                </Avatar>
                <div className="min-w-0">
                    <div className="flex items-center gap-2">
                        <p
                            className="truncate text-sm font-semibold text-foreground"
                            style={{ color: checked ? undefined : '#9b98ad' }}
                            title={ userName }
                        >
                            { userName }
                        </p>
                        <Badge variant={ checked ? 'success' : 'neutral' } size="sm">
                            { checked ? 'Activo' : 'Inactivo' }
                        </Badge>
                    </div>
                    <p className="tabular mt-0.5 truncate text-[13px] text-muted-foreground">
                        { phone }
                    </p>
                </div>
            </div>
            <div className="shrink-0">
                <MenuComponent
                    onClickDisabled={ onClickDisabled }
                    onClickDelete={ onClickDelete }
                    onClickEdit={ onClickEdit }
                    checked={ checked }
                    type={'user'}
                />
            </div>
        </div>
    )
}

export default UserComponentMobile;
